import React, { useEffect, useRef } from 'react';
import { FiCheckCircle, FiShield, FiHeart } from 'react-icons/fi';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Insurance.css';

gsap.registerPlugin(ScrollTrigger);

const Insurance = () => {
  const pageRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo('.info-card', { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.6, stagger: 0.15, ease: 'power2.out' });
      gsap.fromTo('.logo-card', { opacity: 0, scale: 0.9 }, { opacity: 1, scale: 1, duration: 0.5, stagger: 0.05, ease: 'back.out', scrollTrigger: { trigger: '.insurance-logos-grid', start: 'top 80%', toggleActions: 'play none none none' } });
    }, pageRef);
    return () => ctx.revert();
  }, []);

  const logos = Array.from({ length: 26 }, (_, i) => i + 1);

  const getLogoSrc = (num) => {
    if ([13, 19, 20, 22, 23].includes(num)) return `${process.env.PUBLIC_URL}/assets/images/${num}.jpg`;
    if (num === 24) return `${process.env.PUBLIC_URL}/assets/images/${num}.webp`;
    return `${process.env.PUBLIC_URL}/assets/images/${num}.png`;
  };

  return (
    <div className="insurance-page" ref={pageRef}>
      <header
        className="insurance-header"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(10, 36, 34, 0.52) 0%, rgba(10, 36, 34, 0.62) 100%), url(${process.env.PUBLIC_URL}/assets/images/insurence.png)`,
        }}
      >
        <div className="insurance-header-overlay" />
        <div className="insurance-header-content">
          <h1>Cashless Mediclaim & Insurance</h1>
          <p>At Swarup Hospital, Kolhapur, we believe that every patient deserves timely medical care without worrying about financial formalities. That's why we are empanelled with leading health insurance companies and trusted Third-Party Administrators (TPAs), enabling smooth and hassle-free cashless hospitalization.</p>
        </div>
      </header>



      <section className="insurance-marquee-section">
        <div className="marquee-container">
          <div className="marquee-track">
            {logos.map((num) => (<div className="marquee-item" key={`logo-${num}`}><img src={getLogoSrc(num)} alt={`Insurance Partner ${num}`} /></div>))}
            {logos.map((num) => (<div className="marquee-item" key={`logo-dup-${num}`}><img src={getLogoSrc(num)} alt={`Insurance Partner ${num}`} /></div>))}
          </div>
        </div>
      </section>

      <section className="insurance-logos-section">
        <div className="section-header">
          <span className="section-tag">Insurance Companies</span>
          <h2 className="section-title">Cashless Healthcare with Trusted Insurance Partners</h2>
          <p className="section-subtitle">Receive quality medical care without financial stress. Swarup Hospital is proudly associated
            with leading health insurance companies and Third-Party Administrators (TPAs), offering
            seamless cashless hospitalization, quick claim assistance, and dedicated insurance support
            for patients across Kolhapur and surrounding regions.</p>
        </div>
        <div className="insurance-logos-grid">
          {logos.map((num) => (<div className="logo-card" key={`logo-grid-${num}`}><div className="logo-card-inner"><img src={getLogoSrc(num)} alt={`Insurance Provider ${num}`} /></div></div>))}
        </div>
      </section>

      <section className="insurance-info-section" style={{ marginTop: '40px' }}>
        <div className="info-card">
          <FiCheckCircle className="info-icon" />
          <h3>30+ Network Partners</h3>
          <p>Empanelled with 30+ leading insurance providers and TPAs for seamless cashless treatment.</p>
        </div>
        <div className="info-card">
          <FiShield className="info-icon" />
          <h3>Fast Claim Approval</h3>
          <p>Our dedicated insurance desk ensures quick pre-authorization and smooth discharge process.</p>
        </div>
        <div className="info-card">
          <FiHeart className="info-icon" />
          <h3>All Major Policies</h3>
          <p>We accept mediclaim from all major private and government health insurance companies.</p>
        </div>
      </section>
    </div>
  );
};

export default Insurance;
